export type GreetingSlot = "morning" | "afternoon" | "evening";

/** Time-of-day bucket for the Today greeting. */
export function greetingSlot(hour: number): GreetingSlot {
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

/** "Wednesday 3 September" in the app language. */
export function formatTodayDate(
  now: Date,
  language: string | undefined,
): string {
  const locale = language?.startsWith("sv") ? "sv-SE" : "en-US";
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(now);
}
